module.exports = function (app) {
    app.directive('spinner', function () {
        return {
            restrict: 'E',
            scope: {
                status: '=',
                service: '='
            },
            template: "<div class='epr-spinner''><img data-ng-src='/bootstrap/v4/resources/img/loading-40.gif' alt='loadingSpinner'/></div>",
            link: function(scope, elem) {
                scope.$watch("status['"+scope.service+"']",function(){
                    if(scope.status[scope.service]){
                        elem.hide();
                    }else{
                        elem.show();
                    }
                },true);
            }
        };
    });
};
